import { Trans } from "react-i18next";

import commonservice from "@apis/commonservice";
import UploadImage from "@components/UploadImage";
import { useAppSelector } from "@hooks/redux";
import { useLoginHistory } from "@pages/home/login/hooks";
import Modal from "@src/ui/Modal";
import { useShowAccountCrowdModal } from "./hooks";
import { CommonButton } from "@components/CommonButton";
import { LOCALSTORAGE_KEY } from "@config";

const GlobalAccountCrowd = () => {
  const { visibleRemainderCountModal, setVisibleRemainderCountModal } = useShowAccountCrowdModal();
  const { userInfo, region, membership } = useAppSelector((state) => state.globalReducer);
  const { updateListInfo } = useLoginHistory();

  const handleJumpLogin = () => {
    commonservice.logout().then(() => {
      updateListInfo(userInfo.uid, {
        logoutTime: Date.now(),
        lastCountry: region,
        expired: membership?.expired,
        level: membership?.level,
      });
      localStorage.removeItem(LOCALSTORAGE_KEY.ACCESS_TOKEN);
      localStorage.setItem("logined", "false");
      setVisibleRemainderCountModal(false);
      location.href = "/login";
    });
  };
  if (!visibleRemainderCountModal || location.pathname === "/login") return null;
  return (
    <Modal open={visibleRemainderCountModal} className="!w-[412px] z-[1001] " footer={false} closable={false}>
      <div className="flex flex-col items-center justify-center !w-[412px] py-[16px] relative">
        <UploadImage name="806e179f.png" className="h-[71px] absolute top-0 left-0 right-0"></UploadImage>
        <UploadImage name="99a37b4b.webp" className="w-[64px] h-[48px]"></UploadImage>

        <div className="mt-[8px] mb-[12px] px-[51px] flex flex-col items-center">
          <div className="text-left leading-[24px]  ">
            <Trans>
              Your account has been logged in on a new device. If you want to continue using the current device, please
              log in again.
            </Trans>
          </div>
        </div>
        <CommonButton className="px-[24px]  min-w-[133px] h-[34px]" type="primary" onClick={handleJumpLogin}>
          <Trans>Log In</Trans>
        </CommonButton>
      </div>
    </Modal>
  );
};
export default GlobalAccountCrowd;
